import { useState } from "react";
import { useTranslation } from "react-i18next";

import roflag from '../resources/roflag.png';
import enflag from '../resources/enflag.png';

import '../styles/LanguageSelector.css'; 

const LanguageSelector = () => {

    const [selectedFlag, setSelectedFlag] = useState(roflag);
    const [unselectedLanguage, setUnselectedLanguage] = useState('en');


    const { i18n } = useTranslation();

    const changeLanguage = (code) => {
        setSelectedFlag(code === 'ro' ? roflag : enflag);
        setUnselectedLanguage(code === 'ro' ? 'en' : 'ro');
        i18n.changeLanguage(code);
    };


    return (
        <div className="language-selector">
            <img
                src={selectedFlag}
                alt={`Selected language flag`}
                className="language-flag"
                onClick={() => changeLanguage(unselectedLanguage)}
                width={40}
                height={40}
            />
           
        </div>
    );
}

export default LanguageSelector;